<template>
  <div
    v-if="tooltipText"
    v-tooltip.top="tooltipText"
    class="body-smaller label"
    :class="[typeClass, cssClasses]">
    {{ text }}
  </div>
  <div v-else class="body-smaller label" :class="[typeClass, cssClasses]">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    isType: {
      type: String,
      default: 'new'
    },
    text: {
      type: String,
      required: true
    },
    tooltipText: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    typeClass() {
      return `label--${this.isType}`
    }
  }
}
</script>

<style lang="scss">
.label {
  display: inline-block;
  height: 1.625rem;
  line-height: 1.625rem;
  padding: 0 measure(quarter);
  color: color(text-inverted);
  white-space: nowrap;
}

.label--new {
  background-color: color(background-green-2);
}

.label--campaign {
  background-color: color(background-signal);
}

.label--info {
  background-color: color(background-blue);
}

.label--alert {
  background-color: color(background-signal);
}

.label--universal {
  background-color: color(yellow-1);
  color: color(text);
}

</style>
